import { debugGlobals } from '$lib/debug';

let globals: { [key: string]: any } = {};

export const getGlobals = () => globals;

export const setGlobals = (newGlobals: { [key: string]: any }) => {
    debugGlobals('-> setGlobals', newGlobals);

    globals = Object.assign({}, globals, newGlobals);

    return globals;
};

export const getTrackingGlobals = () => {
    const { context, ...rest } = globals;

    return rest;
};
